// Per-instance rows a moving thing's program reads (a person's bones and look, a CPU-posed herd's bones, a herd's coat
// look, the bone a riding part follows): a read-only storage buffer of vec4, the standard way for per-instance data.
// Not a texture: Safari before WebKit 323447@main (iOS 27.3) copies every texture kind a stage reads, and a vertex stage
// reading one compiled in 321 ms against 51 ms for a storage buffer (the owner's iPhone, probe 2 of 2026-11-04). On the
// WebGL2 backend three reads the same numbers through a texture of its own over the same array (setPBO). vec4 elements
// only: Safari packs vec3 ones (scripts/vendor.mjs patchVec3Slots). Method: the skill's references/performance.md.
import * as THREE from 'three/webgpu';
import { storage } from 'three/tsl';
import { pboTexture } from './internals.js'; // VIS-194: three's private parts, checked at start-up

/** n vec4 rows. node.element(i) -> vec4 (TSL); data = the Float32Array to write (read it again after a build: the WebGL2
 *  path swaps in a padded copy); upload() after writing; dispose(). */
export function vec4Rows(n) {
  const attr = new THREE.StorageBufferAttribute(new Float32Array(Math.max(n, 1) * 4), 4);
  return {
    attr, node: storage(attr, 'vec4', Math.max(n, 1)).toReadOnly().setPBO(true),
    get data() { return attr.array; },
    upload() { attr.needsUpdate = true; const t = pboTexture(attr); if (t) t.needsUpdate = true; }, // (WebGL2: three's texture over the array)
    dispose() { attr.dispose(); pboTexture(attr)?.dispose(); },
  };
}
